import { useEffect, useState } from 'react';
import { supabase } from '@services/supabase/client';
import type { CaseDispatchRule } from '@/types/sms';

export const CaseDispatchRules = () => {
  const [rules, setRules] = useState<CaseDispatchRule[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRules();
  }, []);

  const loadRules = async () => {
    const { data, error } = await supabase
      .from('case_dispatch_rules')
      .select(`
        *,
        sms_template:sms_templates(name)
      `)
      .order('event_type');

    if (!error && data) {
      setRules(data);
    }
    setLoading(false);
  };

  const toggleRule = async (ruleId: string, currentStatus: boolean) => {
    await ((supabase
      .from('case_dispatch_rules') as any)
      .update({ is_active: !currentStatus })
      .eq('id', ruleId));
    
    loadRules();
  };

  if (loading) return <div>Loading rules...</div>;

  return (
    <div>
      <h2>Case Dispatch Rules</h2>
      <p className="text-secondary">Configure automatic case creation and SMS notifications based on app events</p>
      
      <div className="table-container" style={{ marginTop: 'var(--spacing-xl)' }}>
        <table className="table">
          <thead>
            <tr>
              <th>Rule Name</th>
              <th>Event Type</th>
              <th>Priority</th>
              <th>Create Case</th>
              <th>Send SMS</th>
              <th>Active</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rules.map((rule) => (
              <tr key={rule.id}>
                <td className="font-weight-600">{rule.name}</td>
                <td className="text-small">{rule.event_type}</td>
                <td>
                  <span className={`priority-badge priority-${rule.case_priority === 'p1' ? 'red' : rule.case_priority === 'p2' ? 'orange' : 'gray'}`}>
                    {rule.case_priority.toUpperCase()}
                  </span>
                </td>
                <td>{rule.create_case ? '✅' : '❌'}</td>
                <td>{rule.send_sms ? '✅' : '❌'}</td>
                <td>
                  <button
                    onClick={() => toggleRule(rule.id, rule.is_active)}
                    className={`status-badge ${rule.is_active ? 'status-green' : 'status-red'}`}
                    style={{ cursor: 'pointer', border: 'none' }}
                  >
                    {rule.is_active ? 'Active' : 'Inactive'}
                  </button>
                </td>
                <td>
                  <button className="btn btn-ghost btn-small">Edit</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <button className="btn btn-primary" style={{ marginTop: 'var(--spacing-lg)' }}>
        + Add New Rule
      </button>
    </div>
  );
};

